<script setup lang="ts">
type Props = {
    title: string
}
defineProps<Props>()
defineEmits<{
    (e: 'close'): void
}>()
</script>

<template>
    <p class="modal-card-title">{{ title }}</p>
</template>

<style scoped lang="scss">
.modal-card-title {
    color: var(--color-text);
    font-size: large;
}
</style>
